/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, ExtendContainerProps, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {$Checkbox} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Checkbox';
import {$UIText} from '../../../JSX/UIText';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {inputNumberValidate} from '@gongxigames/framework/core/utils/inputNumberValidate';
import {$AutoplayInput} from './$AutoplayInput';

export type $AutoplayToggleInputProps = ExtendContainerProps<{
    value: number | null;
    action: (value: number | null) => void;
}>;

export const $AutoplayToggleInput: FC<$AutoplayToggleInputProps> = (props) => {
    const {name, position, action} = props;

    const currencyFormatter = slotStore.currencyFormatter.value!;
    const active = Store.signal(false);
    const inputValue = Store.signal(String(props.value));
    const inputText = Store.computed(() =>
        !inputValue.value ? '' : active.value ? String(inputValue.value) : currencyFormatter.format(Number(inputValue.value)));
    const isValidInput = Store.computed(() =>
        inputValue.value !== '' && inputNumberValidate(inputValue.value) && Number(inputValue.value) > 0);

    const computedInputEffect = Store.effect(() => {
        const value = getProp(props.value);

        if (!value) {
            inputValue.value = '';
        } else {
            inputValue.value = String(value);
        }
    });

    const onChangeInput = (value: string): void => {
        const prevValue = inputValue.value;

        inputValue.value = value;

        if (!inputNumberValidate(value)) {
            inputValue.value = prevValue;
        }
    };

    const onFocusInput = (): void => {
        active.value = true;
    };

    const onBlurInput = (): void => {
        if (isValidInput.value) {
            getProp(action)(Number(inputValue.value));
        } else {
            if (!getProp(props.value)) {
                inputValue.value = '';
            } else {
                getProp(action)(null);
            }
        }

        active.value = false;
    };

    const onToggle = (value: boolean): void => {
        getProp(action)(null);
    };

    return <$Container position={position} events={{destroyed: [computedInputEffect]}}>
        <$Checkbox value={isValidInput} disabled={Store.computed(() => !isValidInput.value)} action={onToggle}/>
        <$UIText
            localeID={name}
            stylePreset='POPUP_TEXT_UPPERCASE'
            style={{align: 'left'}}
            maxWidth={380}
            position={[110, 0]}
        />
        <$AutoplayInput
            inputValue={inputText}
            onInput={onChangeInput}
            onFocus={onFocusInput}
            onBlur={onBlurInput}
        />
    </$Container>;
};

